import { useEffect } from "react";

// Interstitial shown before sending the visitor to the external EXR
// application flow, so leaving the site never comes as a surprise.
export default function ApplyConfirmModal({ listing, applyUrl, onClose }) {
  useEffect(() => {
    const onKeyDown = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  const unitLabel = [listing.unit ? `Residence ${listing.unit}` : null, listing.building]
    .filter(Boolean)
    .join(" at ");

  return (
    <div className="inquire-modal apply-confirm" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="panel" role="dialog" aria-modal="true" aria-label="Continue to application">
        <svg
          className="close"
          onClick={onClose}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 5L5 19M5 5L19 19"
            stroke="#f4e9d7"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg>
        <h3>Ready to Apply?</h3>
        <p className="confirm-text">
          {unitLabel ? `Applications for ${unitLabel} are` : "Your application is"} handled
          securely by EXR, our leasing platform. You'll leave this site to complete your
          application on exrplatform.com.
        </p>
        <div className="confirm-actions">
          <a
            className="button submit"
            href={applyUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClose}
          >
            Continue to EXR
          </a>
          <button type="button" className="button cancel" onClick={onClose}>
            Stay on This Page
          </button>
        </div>
      </div>
    </div>
  );
}
